export const NO_CP_MANAGE_PERMISSION_MESSAGE = 'You do not have permission to create or delete cloud providers.';

export function isCPDisabled(status: string) {
  return !['active', 'upgradecomplete', 'upgrading'].includes(status);
}
